import './styles.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import apiFetch from '@wordpress/api-fetch';
import App from './App.vue';
import router from './router';
import { initMatomo } from './utils/matomo';

if (window.ctData?.nonce) {
  apiFetch.use(apiFetch.createNonceMiddleware(window.ctData.nonce));
}

initMatomo();

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);

app.mount('#contact-tool');
